export default {"src":"/_next/static/media/quote-mark-beginning.76a49eda.svg","height":51,"width":67};